import React, { useContext, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { NotificationContainer } from 'react-notifications';
import {useStore} from "../store"
import {ALERT_MESSAGE_TYPE_SUCCESS} from "../const/Constants"
import AlertComponent from "../utils/Alert";
import { langContext } from "../App";
import { langRegister } from "./registerTranslate";
import "./login.css"
import Lang from "../components/Lang/Lang";
import Footer from "../components/Footer";
import Logo from "../components/Logo";
import CountryCodeSelect from "../components/CountryCodeSelect";
import GoogleSignIn from "../components/GoogleSignIn/GoogleSignIn";
import { isKnownDialCode } from "../const/countryCodes";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

const Register = observer((props) => {
    const lang = useContext(langContext);
    let showBySelected = langRegister[lang]

    const {userStore} = useStore()
    const [data, setData] = useState({
        name: "",
        last_name: "",
        email: "",
        phone_code: "374",
        tel_number: "",
        password: "",
        confirm_password: "",
    })
    const [step, setStep] = useState("form")
    const [code, setCode] = useState("")
    const [errorMessage, setErrorMessage] = useState('')
    const [viewpassword, setViewPassword] = useState("password")
    const [viewrepeat,setViewRepeat] = useState("password")
    const [loading, setLoading] = useState(false)

    const navigate = useNavigate();
    const phoneInputRef = useRef(null);

    const errorText = (result) =>
        showBySelected.errors[result?.payload?.code] || result?.message || showBySelected.tr_pleaseFill

    const handleChange = (e) => {
        const { name, value } = e.target
        setData({ ...data, [name]: value })
        setErrorMessage("")
    }

    const validate = () => {
        const { name, last_name, email, phone_code, tel_number, password, confirm_password } = data
        if (!name.trim() || !last_name.trim() || !email.trim() || !tel_number || !password) {
            return showBySelected.tr_pleaseFill
        }
        if (!EMAIL_RE.test(email.trim())) return showBySelected.errors.EMAIL_INVALID
        if (!isKnownDialCode(phone_code)) return showBySelected.tr_selectCode
        const digits = phone_code + tel_number.replace(/\D/g, "")
        if (digits.length < 8 || digits.length > 15) return showBySelected.errors.PHONE_INVALID
        if (password.length < 8) return showBySelected.tr_passLengthValid
        if (password !== confirm_password) return showBySelected.tr_passwordDontMatch
        return ""
    }

    async function submit() {
        const error = validate()
        if (error) {
            setErrorMessage(error)
            return
        }
        setLoading(true)
        const result = await userStore.register({
            name: data.name.trim(),
            last_name: data.last_name.trim(),
            email: data.email.trim(),
            tel_number: `+${data.phone_code}${data.tel_number.replace(/\D/g, "")}`,
            password: data.password,
        })
        setLoading(false)
        if (!result?.status) {
            setErrorMessage(errorText(result))
            return
        }
        setCode("")
        setStep("verify")
    }

    async function verify() {
        if (!/^\d{6}$/.test(code.trim())) {
            setErrorMessage(showBySelected.errors.CODE_WRONG)
            return
        }
        setLoading(true)
        const result = await userStore.verifyRegistration({ email: data.email.trim(), code: code.trim() })
        setLoading(false)
        if (!result?.status) {
            if (result?.payload?.code === "CODE_EXPIRED") setStep("form")
            setErrorMessage(errorText(result))
            return
        }
        AlertComponent(ALERT_MESSAGE_TYPE_SUCCESS, showBySelected.tr_accountCreated)
        navigate("/")
    }

    async function resend() {
        setErrorMessage("")
        const result = await userStore.resendRegistrationCode({ email: data.email.trim() })
        if (!result?.status) {
            if (result?.payload?.code === "CODE_EXPIRED") setStep("form")
            setErrorMessage(errorText(result))
            return
        }
        AlertComponent(ALERT_MESSAGE_TYPE_SUCCESS, showBySelected.tr_codeResent)
    }

    const onEnter = (action) => (event) => event.key === 'Enter' && !loading && action()

    const textField = (name, placeholder, icon, type = "text") => (
        <>
            <p className="fontstyle label-p">{placeholder}</p>
            <div className='info-center'>
                <div className="info-input-div">
                    <img src={icon} className="icons-input"/>
                    <input type={type} name={name} placeholder={placeholder} value={data[name]}
                        onChange={handleChange}
                        onKeyDown={onEnter(submit)}
                        className="info-input" />
                </div>
            </div>
        </>
    )

    const errorLine = errorMessage ?
        <span className="fontstyle" style={{"color":"tomato", fontSize:"14px"}}>{errorMessage}</span>
        : <div style={{"height":"14px"}}></div>

    const footerLinks = (
        <div className="info-center">
            <div className="help-and">
                <a href={lang === "arm" ? "/armsupport.pdf" : "/engsupport.pdf"} rel="noreferrer" target="_blank"
                        className="fontstyle">
                        {showBySelected.tr_help}
                </a>
                <a href="/"
                        className="fontstyle">
                        {showBySelected.tr_logIn}
                </a>
            </div>
        </div>
    )

    return (
        <div className="login-page" style={{"minHeight": window.innerHeight}}>
            <Lang change={props.change} value={props.value}/>
            <Logo />
            <div className="background-div">
                {step === "form" ? (
                    <div className="info-div">
                        <h3 className="fontstyle head3" >WORK MEETINGS</h3>
                        <h3 className="fontstyle head3" >{showBySelected.tr_confSystem}</h3>
                        <h1 className="fontstyle head1" >{showBySelected.tr_register}</h1>
                        {textField("name", showBySelected.tr_name, "/Iconuser.png")}
                        {textField("last_name", showBySelected.tr_lastName, "/Iconuser.png")}
                        {textField("email", showBySelected.tr_email, "/Iconpin.png", "email")}
                        <p className="fontstyle label-p">{showBySelected.tr_phone}</p>
                        <div className="info-center">
                            {/* login.css gives .info-input-div stray left/top offsets that apply once it is positioned */}
                            <div className="info-input-div" style={{position: "relative", left: 0, top: 0}}>
                                <img src="/Iconpin.png" className="icons-input" />
                                <CountryCodeSelect lang={lang} value={data.phone_code}
                                    onChange={(value) => handleChange({target: {name: "phone_code", value}})}
                                    onSelected={() => phoneInputRef.current?.focus()} />
                                <input type="tel" name="tel_number" ref={phoneInputRef} placeholder={showBySelected.tr_phoneNumber} value={data.tel_number}
                                    onChange={(e) => handleChange({target: {name: "tel_number", value: e.target.value.replace(/[^\d\s()-]/g, "")}})}
                                    onKeyDown={onEnter(submit)}
                                    className="info-input" style={{minWidth: 0, flex: 1}} />
                            </div>
                        </div>
                        <p className="fontstyle label-p">{showBySelected.tr_password}</p>
                        <div className="info-center">
                            <div className="info-input-div">
                                <img src="/Iconpass.png" className="icons-input" />
                                <input type={viewpassword} name="password" placeholder={showBySelected.tr_password} value={data.password}
                                    onKeyDown={onEnter(submit)}
                                    onChange={handleChange}
                                    className="info-input" />
                                <img src={viewpassword === "password" ? "/Iconeye.png" : "/Iconcloseeye.png"} className="eye"
                                    onClick={() => setViewPassword(viewpassword === "password" ? "text" : "password")}/>
                            </div>
                        </div>
                        <p className="fontstyle label-p">{showBySelected.tr_repeatPass}</p>
                        <div className="info-center">
                            <div className="info-input-div">
                                <img src="/Iconpass.png" className="icons-input" />
                                <input type={viewrepeat} name="confirm_password" placeholder={showBySelected.tr_repeatPass} value={data.confirm_password}
                                    onKeyDown={onEnter(submit)}
                                    onChange={handleChange}
                                    className="info-input"/>
                                <img src={viewrepeat === "password" ? "/Iconeye.png" : "/Iconcloseeye.png"} className="eye"
                                    onClick={() => setViewRepeat(viewrepeat === "password" ? "text" : "password")}/>
                            </div>
                        </div>
                        {errorLine}
                        <div className="info-center">
                            <button onClick={submit} disabled={loading} className="fontstyle">
                                {showBySelected.tr_register}
                            </button>
                        </div>
                        <GoogleSignIn />
                        {footerLinks}
                    </div>
                ) : (
                    <div className="info-div">
                        <h3 className="fontstyle head3" >WORK MEETINGS</h3>
                        <h3 className="fontstyle head3" >{showBySelected.tr_confSystem}</h3>
                        <h1 className="fontstyle head1" >{showBySelected.tr_verifyEmail}</h1>
                        <p className="fontstyle label-p">{showBySelected.tr_codeSentTo} <b>{data.email.trim()}</b></p>
                        <div className="info-center">
                            <div className="info-input-div">
                                <img src="/Iconpin.png" className="icons-input" />
                                <input type="text" inputMode="numeric" autoComplete="one-time-code" maxLength={6}
                                    placeholder={showBySelected.tr_code} value={code}
                                    onChange={(e) => {setErrorMessage(""); setCode(e.target.value.replace(/\D/g, ""))}}
                                    onKeyDown={onEnter(verify)}
                                    className="info-input" />
                            </div>
                        </div>
                        {errorLine}
                        <div className="info-center">
                            <button onClick={verify} disabled={loading} className="fontstyle">
                                {showBySelected.tr_confirm}
                            </button>
                        </div>
                        <div className="info-center">
                            <div className="help-and">
                                <a href="#" className="fontstyle" onClick={(e) => {e.preventDefault(); setErrorMessage(""); setStep("form")}}>
                                    {showBySelected.tr_back}
                                </a>
                                <a href="#" className="fontstyle" onClick={(e) => {e.preventDefault(); resend()}}>
                                    {showBySelected.tr_resend}
                                </a>
                            </div>
                        </div>
                    </div>
                )}
                <NotificationContainer />
            </div>
            < Footer />
        </div>
    );
})
export default Register;
